webpackJsonp([2],{

/***/ "./node_modules/hoist-non-react-statics/index.js":
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/rayn/scratch/beta-test-gatsby-site/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/rayn/scratch/beta-test-gatsby-site/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/rayn/scratch/beta-test-gatsby-site/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/rayn/scratch/beta-test-gatsby-site/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/Users/rayn/scratch/beta-test-gatsby-site/node_modules/babel-preset-es2015/lib/index.js\",\"/Users/rayn/scratch/beta-test-gatsby-site/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/rayn/scratch/beta-test-gatsby-site/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    { style: { color: "tomato" } },
	    _react2.default.createElement(
	      "h1",
	      null,
	      "Hello Gatsby!"
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "What a world."
	    ),
	    _react2.default.createElement("img", { src: "http://lorempixel.com/400/200/" }),
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: "/my-second-gatsby-page/" },
	      "Link"
	    ),
	    _react2.default.createElement("br", null),
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: "/counter/" },
	      "Counter"
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-index-js-1ee3fe5be89f8fdd8257.js